import { HarmonyActionType, HarmonyAction } from '../actions/HarmonyActions';
import { Nullable } from '../types/custom/Nullable';
import { HarmonyProductGroup } from '../types/thirdParty/harmony/HarmonyProductGroup';

export interface HarmonyState {
    isHarmonyDirty: boolean,
    harmonyReset: boolean,
    harmonyProductGroup: Nullable<HarmonyProductGroup>,
    enrollmentToken: Nullable<string>,
    isFetching: boolean,
    error: boolean
}

const INITIAL_STATE: HarmonyState = {
    isHarmonyDirty: false,
    harmonyReset: true,
    harmonyProductGroup: null,
    enrollmentToken: null,
    isFetching: false,
    error: false
};

export default function (state = INITIAL_STATE, action: HarmonyAction): HarmonyState {
    switch (action.type) {
        case HarmonyActionType.ON_SUCCESS:
            return {
                ...state,
                isHarmonyDirty: false
            };
        case HarmonyActionType.ON_WIDGET:
            return {
                ...state,
                isHarmonyDirty: true,
                harmonyProductGroup: action.payload as HarmonyProductGroup
            };
        case HarmonyActionType.AFTER_INIT:
            return {
                ...state,
                harmonyReset: false
            };
        case HarmonyActionType.ON_INIT:
            return {
                ...state,
                enrollmentToken: action.payload,
                isFetching: false,
                error: action.payload ? false : true
            };
        case HarmonyActionType.FETCHING:
            return {
                ...state,
                isFetching: true
            };
        default:
            return state;
    }
}